/* Rediseño La Cumbre — «Mis favoritos» (lista de deseos), 100 % Shopify.

   Datos: metacampo del cliente custom.wishlist (list.product_reference). Lo lee Liquid
   y layout/theme.liquid lo deja en #LcWishlistData { loggedIn, customer, accountPage,
   api, ids }. Con eso se pintan los corazones [data-lc-wish] y los contadores.

   Guardar (dos modos):
   1. Instantáneo (api presente: cliente público de la Customer Account API, canal
      Headless). El corazón y el contador cambian al momento y el cambio se escribe con
      metafieldsSet desde el navegador. El primer clic de cada navegador hace un login
      silencioso (prompt=none, PKCE) con vuelta por /pages/wishlist —el callback
      registrado— que aplica el cambio y regresa a la página; después el token se
      renueva solo (refresh_token).
   2. Respaldo: la página «Mis favoritos» de Mi cuenta (app la-cumbre-favoritos-app)
      guarda el cambio: <página>?agregar|quitar=<id>&c=<cliente>&t=<ahora>&volver=<url>.
      Se usa si no hay api o si la API falla.

   Sin sesión: login de la tienda con return_to a esta misma página y ?lc_fav=agregar-<id>;
   al volver con sesión se sigue con el guardado, si el clic salió de este navegador
   (marca en localStorage).

   Tokens: el de acceso (1 h) en sessionStorage, el de renovación en localStorage, ambos
   atados al cliente de Liquid; se borran al cerrar sesión o si cambia el cliente.
   Permisos del cliente público: solo leer/escribir clientes. */
(function () {
  'use strict';
  if (window.LcWishlist) return;

  var dataEl = document.getElementById('LcWishlistData');
  if (!dataEl) return;
  var data = {};
  try { data = JSON.parse(dataEl.textContent) || {}; } catch (e) { data = {}; }
  if (!data.accountPage) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PARAM = 'lc_fav';
  var PENDING_KEY = 'lc_fav_pending';
  var PENDING_MAX_AGE = 30 * 60 * 1000; // el login con código por correo puede tardar
  var MAX_ITEMS = 50; // la tienda lee la lista en Liquid sin paginar
  var MAX_BADGE = 99;
  var designMode = Boolean(window.Shopify && Shopify.designMode);
  var api = data.api && data.api.clientId ? data.api : null;
  var instant = Boolean(api && data.loggedIn && data.customer && window.fetch && window.crypto && crypto.subtle && window.TextEncoder);

  var saved = {};
  var count = 0;
  (Array.isArray(data.ids) ? data.ids : []).forEach(function (id) {
    id = String(id);
    if (/^\d+$/.test(id) && !saved[id]) { saved[id] = true; count++; }
  });

  function has(id) { return saved[String(id)] === true; }
  function setSaved(id, on) {
    id = String(id);
    if (has(id) === on) return;
    if (on) { saved[id] = true; count++; } else { delete saved[id]; count--; }
  }

  /* ---------- URLs ---------- */

  // Búsqueda actual sin el parámetro propio.
  function currentSearch() {
    var params = new URLSearchParams(window.location.search);
    params.delete(PARAM);
    var qs = params.toString();
    return qs ? '?' + qs : '';
  }

  function backUrl(id) {
    return window.location.origin + window.location.pathname + currentSearch() + '#lc-fav-' + id;
  }

  function accountUrl(action, id) {
    var url = data.accountPage;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + action + '=' + encodeURIComponent(id) +
      (data.customer ? '&c=' + encodeURIComponent(data.customer) : '') +
      '&t=' + Date.now() +
      '&volver=' + encodeURIComponent(backUrl(id));
  }

  function loginUrl(id) {
    var params = new URLSearchParams(window.location.search);
    params.set(PARAM, 'agregar-' + id);
    var back = window.location.pathname + '?' + params.toString();
    return ROOT + 'customer_authentication/login?return_to=' + encodeURIComponent(back);
  }

  /* ---------- Almacenamiento ---------- */

  function storeGet(store, key) {
    try { return JSON.parse(window[store].getItem(key) || 'null'); } catch (e) { return null; }
  }
  function storeSet(store, key, value) {
    try {
      if (value == null) window[store].removeItem(key);
      else window[store].setItem(key, JSON.stringify(value));
    } catch (e) { /* sin storage: se usa el respaldo por Mi cuenta */ }
  }

  var REFRESH_KEY = 'lc_caapi';        // localStorage { cid, refresh }
  var ACCESS_KEY = 'lc_caapi_access';  // sessionStorage { cid, access, exp }
  var AUTH_KEY = 'lc_caapi_auth';      // sessionStorage: login silencioso en curso

  function clearTokens() {
    storeSet('localStorage', REFRESH_KEY, null);
    storeSet('sessionStorage', ACCESS_KEY, null);
  }
  // Sesión cerrada o cliente distinto: los tokens guardados no sirven.
  (function () {
    var r = storeGet('localStorage', REFRESH_KEY);
    var a = storeGet('sessionStorage', ACCESS_KEY);
    if (!data.loggedIn || (r && r.cid !== data.customer) || (a && a.cid !== data.customer)) clearTokens();
  })();

  /* ---------- Pintado ---------- */

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  // No es un interruptor de estado puro (puede salir a Mi cuenta): el nombre dice la acción.
  function paintButton(btn) {
    var on = has(btn.getAttribute('data-product-id'));
    var title = btn.getAttribute('data-product-title') || 'este producto';
    var label = on
      ? 'Quitar «' + title + '» de mis favoritos'
      : data.loggedIn
        ? 'Agregar «' + title + '» a mis favoritos'
        : 'Inicia sesión para guardar «' + title + '» en mis favoritos';
    setAttr(btn, 'aria-label', label);
    setAttr(btn, 'title', on ? 'Quitar de mis favoritos' : data.loggedIn ? 'Agregar a mis favoritos' : 'Inicia sesión para guardar en favoritos');
    if (btn.classList.contains('is-active') !== on) btn.classList.toggle('is-active', on);
  }

  function paintCounters() {
    var text = count > MAX_BADGE ? MAX_BADGE + '+' : String(count);
    var counts = document.querySelectorAll('[data-lc-wish-count]');
    for (var i = 0; i < counts.length; i++) {
      if (counts[i].textContent !== text) counts[i].textContent = text;
      counts[i].hidden = count === 0;
    }
    var label = count === 0 ? 'Mis favoritos' : 'Mis favoritos, ' + count + (count === 1 ? ' producto' : ' productos');
    var links = document.querySelectorAll('[data-lc-wish-link]');
    for (var j = 0; j < links.length; j++) setAttr(links[j], 'aria-label', label);
  }

  function paintAll() {
    var nodes = document.querySelectorAll('[data-lc-wish]');
    for (var i = 0; i < nodes.length; i++) paintButton(nodes[i]);
    paintCounters();
  }

  // Todos los corazones de ese producto (clones de Slick incluidos).
  function setBusy(id, busy) {
    var nodes = document.querySelectorAll('[data-lc-wish][data-product-id="' + id + '"]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.toggle('is-busy', busy);
      if (busy) nodes[i].setAttribute('aria-busy', 'true'); else nodes[i].removeAttribute('aria-busy');
    }
  }

  function pop(id) {
    var nodes = document.querySelectorAll('[data-lc-wish][data-product-id="' + id + '"]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.remove('is-popping');
      void nodes[i].offsetWidth; // reinicia la animación
      nodes[i].classList.add('is-popping');
    }
  }
  document.addEventListener('animationend', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.lc-wish.is-popping') : null;
    if (btn) btn.classList.remove('is-popping');
  });

  // Aviso para lectores de pantalla (sin modales ni avisos visibles).
  var live = null;
  function announce(text) {
    if (!live) {
      live = document.createElement('p');
      live.className = 'visually-hidden';
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 50);
  }

  /* ---------- Página «Mis favoritos»: quitar en el lugar ---------- */

  function removeCard(id) {
    var grid = document.querySelector('[data-lc-wishpage-grid]');
    if (!grid) return;
    var li = grid.querySelector('[data-lc-wish-item="' + id + '"]');
    if (!li || li.classList.contains('is-removing')) return;
    var hadFocus = li.contains(document.activeElement);
    var next = li.nextElementSibling || li.previousElementSibling;
    li.classList.add('is-removing');
    setTimeout(function () {
      li.remove();
      var left = grid.querySelectorAll('[data-lc-wish-item]').length;
      var countEl = document.querySelector('[data-lc-wishpage-count]');
      if (countEl) {
        countEl.textContent = left ? left + (left === 1 ? ' producto' : ' productos') : '';
        countEl.hidden = !left;
      }
      if (!left) {
        grid.hidden = true;
        var empty = document.querySelector('[data-lc-wishpage-empty]');
        if (empty) { empty.hidden = false; if (hadFocus) empty.focus(); }
      } else if (hadFocus && next) {
        var target = next.querySelector('[data-lc-wish], a[href], button');
        if (target) target.focus();
      }
    }, 260);
  }

  /* ---------- Customer Account API ---------- */

  function b64url(bytes) {
    var s = '';
    var b = new Uint8Array(bytes);
    for (var i = 0; i < b.length; i++) s += String.fromCharCode(b[i]);
    return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function randomString() {
    var a = new Uint8Array(32);
    crypto.getRandomValues(a);
    return b64url(a);
  }
  function sha256(value) {
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(value)).then(b64url);
  }
  function jwtPayload(token) {
    var p = String(token || '').split('.')[1] || '';
    p = p.replace(/-/g, '+').replace(/_/g, '/');
    while (p.length % 4) p += '=';
    return JSON.parse(decodeURIComponent(escape(atob(p))));
  }

  // Petición «simple» (form-urlencoded, sin cabeceras propias): el endpoint de tokens no
  // acepta el preflight CORS. El navegador agrega Origin, que debe estar en Headless.
  function tokenRequest(params) {
    return fetch(api.authBase + '/oauth/token', {
      method: 'POST',
      cache: 'no-store',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(params)
    });
  }

  function saveTokens(json) {
    storeSet('sessionStorage', ACCESS_KEY, {
      cid: data.customer,
      access: json.access_token,
      exp: Date.now() + (Number(json.expires_in) || 0) * 1000
    });
    var prev = storeGet('localStorage', REFRESH_KEY);
    storeSet('localStorage', REFRESH_KEY, {
      cid: data.customer,
      refresh: json.refresh_token || (prev && prev.refresh) || null
    });
  }

  var refreshing = null;
  function accessToken() {
    var a = storeGet('sessionStorage', ACCESS_KEY);
    if (a && a.cid === data.customer && a.access && a.exp > Date.now() + 60000) return Promise.resolve(a.access);
    var r = storeGet('localStorage', REFRESH_KEY);
    if (!r || r.cid !== data.customer || !r.refresh) return Promise.resolve(null);
    if (!refreshing) {
      refreshing = tokenRequest({ grant_type: 'refresh_token', client_id: api.clientId, refresh_token: r.refresh })
        .then(function (res) {
          if (res.status === 400 || res.status === 401) { clearTokens(); return null; } // sesión vencida
          if (!res.ok) throw new Error('refresh HTTP ' + res.status);
          return res.json().then(function (json) {
            saveTokens(json);
            return json.access_token;
          });
        })
        .finally(function () { refreshing = null; });
    }
    return refreshing;
  }

  function apiError(code, detail) {
    var e = new Error(code + (detail ? ': ' + detail : ''));
    e.code = code;
    return e;
  }

  // keepalive en las escrituras: terminan aunque el cliente cambie de página enseguida.
  function graphql(query, variables, retried, keepalive) {
    return accessToken().then(function (token) {
      if (!token) throw apiError('NO_TOKEN');
      return fetch(api.graphql, {
        method: 'POST',
        cache: 'no-store',
        credentials: 'omit',
        keepalive: Boolean(keepalive),
        headers: { 'Content-Type': 'application/json', 'Authorization': token },
        body: JSON.stringify({ query: query, variables: variables || {} })
      }).then(function (res) {
        if (res.status === 401 && !retried) {
          storeSet('sessionStorage', ACCESS_KEY, null); // vencido: se renueva una vez
          return graphql(query, variables, true, keepalive);
        }
        if (res.status === 401) throw apiError('NO_TOKEN');
        return res.json().then(function (json) {
          if (!res.ok || (json.errors && json.errors.length)) {
            throw apiError('API', (json.errors || []).map(function (x) { return x.message; }).join('; ') || 'HTTP ' + res.status);
          }
          return json.data;
        });
      });
    });
  }

  var Q_READ = 'query{customer{id metafield(namespace:"custom",key:"wishlist"){value compareDigest}}}';
  var M_SET = 'mutation($m:[MetafieldsSetInput!]!){metafieldsSet(metafields:$m){metafields{key compareDigest}userErrors{field message code}}}';
  var M_DELETE = 'mutation($m:[MetafieldIdentifierInput!]!){metafieldsDelete(metafields:$m){deletedMetafields{key}userErrors{field message code}}}';
  var CONFLICT = ['STALE_OBJECT', 'INVALID_COMPARE_DIGEST'];

  // Último estado conocido del metacampo (lista + compareDigest). Con él, los clics
  // siguientes hacen una sola petición; si otra pestaña escribió antes, el
  // compareDigest no coincide y se relee.
  var remote = null;
  function readRemote() {
    return graphql(Q_READ).then(function (d) {
      var mf = d.customer.metafield;
      var ids = [];
      if (mf && mf.value) {
        try { ids = JSON.parse(mf.value) || []; } catch (e) { ids = []; }
      }
      remote = { owner: d.customer.id, ids: ids, digest: mf ? mf.compareDigest : null };
      return remote;
    });
  }

  function writeRemote(action, id, attempt) {
    attempt = attempt || 0;
    var gid = 'gid://shopify/Product/' + id;
    return (remote ? Promise.resolve(remote) : readRemote()).then(function (st) {
      var ids = st.ids;
      var next;
      if (action === 'agregar') {
        if (ids.indexOf(gid) !== -1) return null;
        if (ids.length >= MAX_ITEMS) throw apiError('LISTA_LLENA');
        next = [gid].concat(ids);
      } else {
        next = ids.filter(function (x) { return x !== gid; });
        if (next.length === ids.length) return null;
      }
      var call = next.length
        ? graphql(M_SET, { m: [{ ownerId: st.owner, namespace: 'custom', key: 'wishlist', type: 'list.product_reference', value: JSON.stringify(next), compareDigest: st.digest }] }, false, true)
            .then(function (r) {
              var errors = r.metafieldsSet.userErrors;
              var mf = r.metafieldsSet.metafields && r.metafieldsSet.metafields[0];
              if (!errors.length) remote = { owner: st.owner, ids: next, digest: mf ? mf.compareDigest : null };
              return errors;
            })
        : graphql(M_DELETE, { m: [{ ownerId: st.owner, namespace: 'custom', key: 'wishlist' }] }, false, true)
            .then(function (r) {
              var errors = r.metafieldsDelete.userErrors;
              if (!errors.length) remote = { owner: st.owner, ids: [], digest: null };
              return errors;
            });
      return call.then(function (errors) {
        if (!errors || !errors.length) return null;
        remote = null; // ya no se sabe el estado: se relee
        var conflict = errors.some(function (e) { return CONFLICT.indexOf(e.code) !== -1; });
        if (conflict && attempt < 1) return writeRemote(action, id, attempt + 1);
        throw apiError('API', errors.map(function (e) { return e.code + ' ' + e.message; }).join('; '));
      });
    }).catch(function (err) { remote = null; throw err; });
  }

  /* ---------- Login silencioso (prompt=none) ---------- */

  // Navegación completa: Shopify no permite el login en un iframe. Vuelve a /pages/wishlist
  // (el callback registrado en Headless), que aplica el cambio pendiente y regresa aquí.
  function startSilentAuth(action, id) {
    var verifier = randomString();
    var state = randomString();
    var nonce = randomString();
    return sha256(verifier).then(function (challenge) {
      storeSet('sessionStorage', AUTH_KEY, {
        state: state, nonce: nonce, verifier: verifier, action: action, id: id,
        back: window.location.pathname + currentSearch() + '#lc-fav-' + id,
        t: Date.now()
      });
      var url = new URL(api.authBase + '/oauth/authorize');
      var q = url.searchParams;
      q.set('client_id', api.clientId);
      q.set('response_type', 'code');
      q.set('scope', 'openid email customer-account-api:full');
      q.set('redirect_uri', api.callback);
      q.set('state', state);
      q.set('nonce', nonce);
      q.set('code_challenge', challenge);
      q.set('code_challenge_method', 'S256');
      q.set('prompt', 'none');
      q.set('locale', 'es');
      window.location.assign(url.toString());
    });
  }

  // En /pages/wishlist?code=…&state=… (o ?error=…): canjea el código, aplica el cambio y vuelve.
  function handleCallback() {
    if (!api || window.location.origin + window.location.pathname !== api.callback) return false;
    var params = new URLSearchParams(window.location.search);
    var state = params.get('state');
    if (!state || (!params.get('code') && !params.get('error'))) return false;
    var pending = storeGet('sessionStorage', AUTH_KEY);
    storeSet('sessionStorage', AUTH_KEY, null);
    window.history.replaceState(window.history.state, '', window.location.pathname); // el código no queda en la URL
    if (!pending || pending.state !== state || Date.now() - pending.t > 10 * 60 * 1000) return false;

    var back = pending.back && pending.back.charAt(0) === '/' && pending.back.charAt(1) !== '/' ? pending.back : '/';
    var fallback = function () { window.location.replace(accountUrl(pending.action, pending.id)); };

    if (params.get('error')) {
      // login_required: la sesión de Shopify venció aunque la tienda muestre al cliente.
      if (params.get('error') === 'login_required' && pending.action === 'agregar') {
        try { window.localStorage.setItem(PENDING_KEY, JSON.stringify({ id: pending.id, t: Date.now() })); } catch (e) {}
        var q = new URLSearchParams(back.split('#')[0].split('?')[1] || '');
        q.set(PARAM, 'agregar-' + pending.id);
        window.location.replace(ROOT + 'customer_authentication/login?return_to=' +
          encodeURIComponent(back.split('?')[0].split('#')[0] + '?' + q.toString()));
      } else {
        fallback();
      }
      return true;
    }

    tokenRequest({
      grant_type: 'authorization_code',
      client_id: api.clientId,
      redirect_uri: api.callback,
      code: params.get('code'),
      code_verifier: pending.verifier
    })
      .then(function (res) {
        if (!res.ok) throw new Error('token HTTP ' + res.status);
        return res.json();
      })
      .then(function (json) {
        var claims = jwtPayload(json.id_token);
        var aud = [].concat(claims.aud);
        if (claims.nonce !== pending.nonce || claims.iss !== api.authBase || aud.indexOf(api.clientId) === -1) {
          throw new Error('id_token inválido');
        }
        saveTokens(json);
        return writeRemote(pending.action, pending.id);
      })
      .then(function () { window.location.replace(back); })
      .catch(function (err) {
        if (window.console) console.warn('[LcWishlist] login silencioso falló; se usa Mi cuenta.', err);
        fallback();
      });
    return true;
  }

  /* ---------- Acciones ---------- */

  var leaving = false;
  var leftForAccount = false;
  var queue = Promise.resolve();

  function go(url, id) {
    leaving = true;
    leftForAccount = true;
    if (id) setBusy(id, true);
    // Si la navegación no se concreta (se canceló), se libera el corazón.
    setTimeout(function () { leaving = false; if (id) setBusy(id, false); }, 8000);
    window.location.assign(url);
  }

  // Corazón instantáneo: pinta ya, guarda en segundo plano (en cola) y, si no hay token,
  // hace el login silencioso que termina el guardado.
  function toggleInstant(id) {
    var action = has(id) ? 'quitar' : 'agregar';
    setSaved(id, action === 'agregar');
    paintAll();
    if (action === 'agregar') pop(id);
    else removeCard(id);
    announce(action === 'agregar' ? 'Agregado a tus favoritos' : 'Quitado de tus favoritos');

    queue = queue.then(function () {
      if (leaving) return null;
      return writeRemote(action, id).catch(function (err) {
        if (err && err.code === 'NO_TOKEN') {
          leaving = true;
          return startSilentAuth(action, id).catch(function () { go(accountUrl(action, id), id); });
        }
        // Otro error (red, lista llena, API): se revierte y se guarda por Mi cuenta.
        if (window.console) console.warn('[LcWishlist] no se pudo guardar al instante; se usa Mi cuenta.', err);
        setSaved(id, action !== 'agregar');
        paintAll();
        go(accountUrl(action, id), id);
        return null;
      });
    });
  }

  document.addEventListener('click', function (e) {
    var target = e.target && e.target.closest ? e.target : null;
    if (!target) return;
    var link = target.closest('a[href]');
    if (link && link.href.indexOf(data.accountPage) === 0) leftForAccount = true; // «Administrar en Mi cuenta»

    var btn = target.closest('[data-lc-wish]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-product-id') || '';
    if (!/^\d+$/.test(id) || leaving) return;
    if (designMode) { btn.classList.toggle('is-active'); return; } // en el editor del tema no se guarda

    if (!data.loggedIn) {
      try { window.localStorage.setItem(PENDING_KEY, JSON.stringify({ id: id, t: Date.now() })); } catch (err) { /* sin storage: no habrá reanudación */ }
      go(loginUrl(id), id);
      return;
    }
    if (instant) { toggleInstant(id); return; }
    go(accountUrl(has(id) ? 'quitar' : 'agregar', id), id);
  });

  // Volver con el botón atrás puede restaurar la página vieja desde la caché del
  // navegador (corazón y contador sin actualizar): se recarga para leer el metacampo.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && (leftForAccount || document.querySelector('[data-lc-wish].is-busy'))) window.location.reload();
  });

  // Cards inyectadas después de la carga: relacionados (Section Rendering), filtros
  // de colección (facets.js), clones de Slick al cambiar de tamaño, editor del tema.
  var queued = false;
  function queuePaint() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      queued = false;
      paintAll();
    });
  }
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      if (queued) return;
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches('[data-lc-wish],[data-lc-wish-count]') || node.querySelector('[data-lc-wish],[data-lc-wish-count]')) {
            queuePaint();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', queuePaint);

  // Regreso del login de la tienda (?lc_fav=agregar-<id>): se limpia la URL y, si el
  // clic salió de este navegador hace poco, ya hay sesión y falta el cambio, se guarda.
  // Un enlace armado en otro sitio no tiene la marca.
  function resumeAfterLogin() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var value = params.get(PARAM);
    if (!value) return;
    window.history.replaceState(window.history.state, '', window.location.pathname + currentSearch() + window.location.hash);

    var pending = null;
    try {
      pending = JSON.parse(window.localStorage.getItem(PENDING_KEY));
      window.localStorage.removeItem(PENDING_KEY);
    } catch (e) { pending = null; }

    var m = /^agregar-(\d{1,20})$/.exec(value);
    if (!m || !data.loggedIn || has(m[1])) return;
    if (!pending || pending.id !== m[1] || !(Date.now() - pending.t < PENDING_MAX_AGE)) return;
    if (instant) toggleInstant(m[1]);
    else go(accountUrl('agregar', m[1]), m[1]); // assign: «atrás» desde Mi cuenta vuelve aquí
  }

  // Regreso desde Mi cuenta o del login silencioso (#lc-fav-<id>): vista al corazón tocado.
  function restoreScroll() {
    var m = /^#lc-fav-(\d{1,20})$/.exec(window.location.hash);
    if (!m) return;
    window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
    var nodes = document.querySelectorAll('[data-lc-wish][data-product-id="' + m[1] + '"]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].closest('.slick-cloned') || !nodes[i].offsetParent) continue;
      nodes[i].scrollIntoView({ block: 'center' });
      try { nodes[i].focus({ preventScroll: true }); } catch (e) { nodes[i].focus(); }
      return;
    }
  }

  /* ---------- API pública ---------- */

  window.LcWishlist = {
    has: has,
    count: function () { return count; },
    ids: function () { return Object.keys(saved); },
    url: accountUrl,
    instant: function () { return instant; },
    sync: paintAll
  };

  if (handleCallback()) return; // la página se va a reemplazar
  paintAll();
  resumeAfterLogin();
  // Después de load: los carruseles (Slick) ya acomodaron las cards.
  if (document.readyState === 'complete') restoreScroll();
  else window.addEventListener('load', restoreScroll, { once: true });
})();
